<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Dn Performance Report</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by From</u></label>
        <input type="date" [(ngModel)]="filterable.from" class="form-control" placeholder="From">
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by To</u></label>
        <input type="date" [(ngModel)]="filterable.to" class="form-control" placeholder="To">
      </div>
      <div class="col">
        <label for="gotoShortCode"><u>Goto ShortCode</u></label>
        <ng-select [items]="allShortCodes" bindLabel="scView" placeholder="Goto ShortCode" [(ngModel)]="targetShortCode" class="form-control" (ngModelChange)="gotoTargetShortCode($event)">
        </ng-select>
      </div>
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Source</u></label>
        <select [(ngModel)]="filterable.source" class="form-control" placeholder="Source" (ngModelChange)="changeSource($event)">
          <option *ngFor="let source of sourceList" [ngValue]="source">{{source.name}}</option>
        </select>
      </div>

    </div>
    <div class="row">
      <div class="col">
        <label for=""><span class="text-danger">* </span><u>Filter by Country</u></label>
        <select [(ngModel)]="filterable.country" class="form-control" placeholder="Country" (ngModelChange)="changeCountry($event)">
          <option *ngFor="let country of countryList | keyvalue" [ngValue]="country.value" >{{country.key}}</option>
        </select>
      </div>
      <div class="col">
        <label for="shortCode"><u>Filter by Short Code</u></label>
        <ng-select [items]="shortCodeList" bindLabel="shortCode" (clear)="onClear()" placeholder="Select short code" [(ngModel)]="filterable.shortCode" class="form-control" (ngModelChange)="changeShortCode($event)">
        </ng-select>
      </div>
      <div class="col">
        <label for=""><u>Filter by Keyword</u></label>
        <select [(ngModel)]="filterable.keyword" class="form-control" placeholder="Keyword" (ngModelChange)="changeKeyword($event)">
          <option value=null>-select keyword-</option>
          <option *ngFor="let kw of keywordList" [ngValue]="kw">{{kw.keyword}}</option>
        </select>
      </div>
      <div class="col" *ngIf="affiliateList != null && affiliateList.length > 0">
        <label for=""><u>Filter by Affiliate</u> <i class="fas" placement="right" ngbTooltip="'NULL': affiliate is null before affiliate is enabled">'NULL'</i>
          &nbsp;<i class="fas" placement="right" ngbTooltip="'-': it's default value when affiliate is null after affiliate is enabled">'-'</i>
        </label>
        <select [(ngModel)]="filterable.affiliate" class="form-control" placeholder="Affiliate" [disabled]="">
          <option value='' selected>-select affiliate-</option>
          <option *ngFor="let af of affiliateList" [ngValue]="af">{{af}}</option>
        </select>
      </div>
      <div class="col">
        <label for=""><u>Data Flag</u></label>
        <select [(ngModel)]="filterable.realtime" class="form-control" placeholder="realtime">
          <option *ngFor="let rtf of realtimeFlags | keyvalue" [ngValue]="rtf.value">{{rtf.key}}</option>
        </select>
      </div>

      <!-- <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div> -->
    </div>
  </div>
</div>

<div class="mt-3 mb-2 row">
  <div class="col align-self-center">
    <span  *ngIf="resultName != ''"  ><span class="font-weight-bold font-italic text-danger">{{resultName}}</span> </span>
  </div>
  <div class="col align-self-end text-right">
    <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
    <button class="btn btn-success btn-sm mr-2" (click)="export()" *ngIf="!exporting">Export</button>
    <button class="btn btn-success btn-sm mr-2" disabled *ngIf="exporting">Exporting..</button>
    <button class="btn btn-success btn-sm mr-2 d-none" id="download" (click)="openModal(viewDownloadUrl)">Open</button>
  </div>
</div>

<div *ngIf="emptyResult">
  <div class="loader" *ngIf="loading">Loading...</div>
  <div class="alert alert-warning mt-3 w-100" *ngIf="!loading">Empty Result...</div>
</div>

<div *ngIf="!emptyResult">
  <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs mt-4">
    <li [ngbNavItem]="1">
      <a ngbNavLink>
        <h5>Total</h5>
      </a>
      <ng-template ngbNavContent>
        <div class="mt-3 mb-2 row">
          <div class="col-12 text-center">
            <h3 class="mb-0">Total</h3>
          </div>
        </div>
        <div class="outer">
          <div class="inner" [ngStyle]="{'margin-left': headingValues.length > 16 ? '100px' : '0' }">
            <table id="dnPerformanceList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
              <thead>
                <tr>
                  <th class="fix" [ngStyle]="headingValues.length > 16 ? {'position': 'absolute', 'margin-left': '-100px'} : ''">Operator</th>
                  <th *ngFor="let dnPerformanceTh of headingValues">{{dnPerformanceTh.day}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="loading">
                  <td colspan="12">
                    <div class="loader">Loading...</div>
                  </td>
                </tr>
                <tr *ngFor="let dnPerformanceTd of dnPerformances | keyvalue">
                  <td class="fix" [ngStyle]="headingValues.length > 16 ? {'position': 'absolute', 'margin-left': '-100px'} : ''">{{dnPerformanceTd.key}}</td>
                  <td class="text-right" *ngFor="let val of dnPerformanceTd.value">{{val.total}}</td>
                </tr>
              </tbody>
              <tfoot>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="card" *ngIf="!loading">
          <div class="card-header">
            TOTAL
            <div class="card-header-actions small">
              x-axis: date <br>
              y-axis: total count
            </div>
          </div>
          <div class="card-body col-9 m-auto">
            <div class="chart-wrapper">
              <canvas baseChart class="chart" [datasets]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions" [colors]="lineChartColours" [legend]="lineChartLegend" [chartType]="lineChartType"
                (chartClick)="chartClicked($event)"></canvas>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="2">
      <a ngbNavLink>
        <h5>Success</h5>
      </a>
      <ng-template ngbNavContent>
        <div class="mt-3 mb-2 row">
          <div class="col-12 text-center">
            <h3 class="mb-0">Success</h3>
          </div>
        </div>
        <div class="outer">
          <div class="inner" [ngStyle]="{'margin-left': headingValues.length > 16 ? '100px' : '0' }">
            <table id="dnPerformanceSList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
              <thead>
                <tr>
                  <th class="fix" [ngStyle]="headingValues.length > 16 ? {'position': 'absolute', 'margin-left': '-100px'} : ''">Operator</th>
                  <th  *ngFor="let dnPerformanceTh of headingValues">{{dnPerformanceTh.day}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="loading">
                  <td colspan="12">
                    <div class="loader">Loading...</div>
                  </td>
                </tr>
                <!-- <tr *ngIf="emptyResult">
            <td colspan="12">
              <div class="alert alert-warning">Empty Result...</div>
            </td>
          </tr> -->
                <tr *ngFor="let dnPerformanceTd of dnPerformances | keyvalue">
                  <td class="fix" [ngStyle]="headingValues.length > 16 ? {'position': 'absolute', 'margin-left': '-100px'} : ''">{{dnPerformanceTd.key}}</td>
                  <td class="text-right" *ngFor="let val of dnPerformanceTd.value">{{val.success}}</td>
                </tr>
              </tbody>
              <tfoot>
              </tfoot>
            </table>
          </div>
        </div>

        <div class="card" *ngIf="!loading">
          <div class="card-header">
            SUCCESS
            <div class="card-header-actions small">
              x-axis: date <br>
              y-axis: success count
            </div>
          </div>
          <div class="card-body col-9 m-auto">
            <div class="chart-wrapper">
              <canvas baseChart class="chart" [datasets]="lineChartSuccessData" [labels]="lineChartLabels" [options]="lineChartOptions" [colors]="lineChartColours" [legend]="lineChartLegend" [chartType]="lineChartType"
                (chartClick)="chartClicked($event)"></canvas>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
    <li [ngbNavItem]="3">
      <a ngbNavLink>
        <h5>Success Rate</h5>
      </a>
      <ng-template ngbNavContent>
        <div class="mt-3 mb-2 row">
          <div class="col-12 text-center">
            <h3 class="mb-0">Success Rate</h3>
          </div>
        </div>
        <div class="outer">
          <div class="inner" [ngStyle]="{'margin-left': headingValues.length > 16 ? '100px' : '0' }">
            <table id="dnPerformanceSRList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
              <thead>
                <tr>
                  <th class="fix" [ngStyle]="headingValues.length > 16 ? {'position': 'absolute', 'margin-left': '-100px'} : ''">Operator</th>
                  <th *ngFor="let dnPerformanceTh of headingValues">{{dnPerformanceTh.day}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="loading">
                  <td colspan="12">
                    <div class="loader">Loading...</div>
                  </td>
                </tr>
                <!-- <tr *ngIf="emptyResult">
            <td colspan="12">
              <div class="alert alert-warning">Empty Result...</div>
            </td>
          </tr> -->
                <tr *ngFor="let dnPerformanceTd of dnPerformances | keyvalue">
                  <td class="fix" [ngStyle]="headingValues.length > 16 ? {'position': 'absolute', 'margin-left': '-100px'} : ''">{{dnPerformanceTd.key}}</td>
                  <td class="text-right" *ngFor="let val of dnPerformanceTd.value">
                    <span *ngIf="val.total == 0">
                      0
                    </span>
                    <span *ngIf="val.total > 0">
                      {{ (val.success / val.total) * 100 | number}}%
                    </span>
                  </td>
                </tr>
              </tbody>
              <tfoot>
              </tfoot>
            </table>
          </div>
        </div>

        <div class="card" *ngIf="!loading">
          <div class="card-header">
            SUCCESS RATE
            <div class="card-header-actions small">
              x-axis: date <br>
              y-axis: success count
            </div>
          </div>
          <div class="card-body col-9 m-auto">
            <div class="chart-wrapper">
              <canvas baseChart class="chart" [datasets]="lineChartSuccessRateData" [labels]="lineChartLabels" [options]="lineChartOptions" [colors]="lineChartColours" [legend]="lineChartLegend" [chartType]="lineChartType"
                (chartClick)="chartClicked($event)"></canvas>
            </div>
          </div>
        </div>
      </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav" class="mt-2 mb-4"></div>
</div>

<ng-template #viewDownloadUrl let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="downloadUrl-header">Download URL</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group row">
      <div class="col-12">
        Click to download:
        <a href={{downloadUrl}} target="_blank">
          {{downloadUrl}}
        </a>
      </div>
    </div>
  </div>
</ng-template>
